import BlurFadeText from "@/components/common/blurFadeText";

export default function SectionTitle({
  as: Tag = "h2",
  text,
  children,
  className = "",
  id,
  light = false,
  delay = 0.08,
  blur = 11,
  y = 20,
  amount = 0.45,
}) {
  const defaultClassName = light
    ? "font-raleway font-semibold leading-[0.94] tracking-[-0.065em] text-white"
    : "font-raleway font-semibold leading-[0.94] tracking-[-0.065em] text-[#06040c]";

  return (
    <Tag id={id} className={`${defaultClassName} ${className}`.trim()}>
      <BlurFadeText
        text={typeof text === "string" ? text : undefined}
        delay={delay}
        blur={blur}
        y={y}
        amount={amount}
      >
        {children}
      </BlurFadeText>
    </Tag>
  );
}
